import React from 'react';

function useInitialMount() {
  const isInitialMount = React.useRef(true);

  if (isInitialMount.current) {
    isInitialMount.current = false;

    return true;
  }

  return false;
}

export default useInitialMount;
